import { theme } from 'antd';
import type { ThemeConfig } from 'antd';
import { lightColors, darkColors } from './colors';

const { darkAlgorithm, defaultAlgorithm } = theme;

export const getAntdTheme = (isDark: boolean): ThemeConfig => {
  const colors = isDark ? darkColors : lightColors;

  return {
    algorithm: isDark ? darkAlgorithm : defaultAlgorithm,
    token: {
      colorPrimary: colors.primary,
      colorBgContainer: colors.surface,
      colorBgLayout: colors.background,
      colorText: colors.text,
      colorTextSecondary: colors.textSecondary,
      colorBorder: colors.border,
      colorBorderSecondary: colors.borderLight,
      colorSuccess: colors.success,
      colorError: colors.error,
      colorWarning: colors.warning,
      colorInfo: colors.info,
      borderRadius: 8,
    },
    components: {
      Layout: {
        siderBg: colors.surface,
        headerBg: colors.surface,
      },
      Menu: {
        itemBg: 'transparent',
        itemColor: colors.textSecondary,
        itemHoverColor: colors.primary,
        itemSelectedColor: colors.primary,
      },
      Card: {
        colorBgContainer: colors.surface,
      },
      Modal: {
        contentBg: colors.surface,
        headerBg: colors.surface,
      },
      Table: {
        headerBg: colors.backgroundSecondary,
        rowHoverBg: colors.surfaceHover,
      },
      Input: {
        colorBgContainer: colors.surface,
        colorBorder: colors.border,
      },
      Button: {
        controlHeight: 40,
        paddingInline: 16,
        paddingBlock: 8,
        onlyIconSize: 20,

        // Primary button
        colorPrimary: colors.primary,
        colorTextLightSolid: '#FFFFFF', // Text for primary

        // Default (Secondary) button states
        defaultBg: colors.surface,
        defaultBorderColor: colors.border,
        defaultColor: colors.text,
        defaultHoverBg: colors.backgroundHover,
        defaultHoverBorderColor: colors.borderHover,
        defaultHoverColor: colors.text,
        defaultActiveBg: colors.surfaceHover,
        defaultActiveBorderColor: colors.primaryHover,
        defaultActiveColor: colors.primaryHover,

        // Text (Plain) button states
        textHoverBg: colors.backgroundHover,
        colorText: colors.textSecondary,
        colorTextBase: colors.text,

        // Primary button hover/active states
        colorPrimaryHover: colors.primaryHover,
        colorPrimaryActive: colors.primaryActive,

        // Danger button states
        colorError: colors.error,
        colorErrorHover: colors.errorHover,
        colorErrorActive: colors.errorDark,

        // Disabled states
        colorBgContainerDisabled: colors.gray100,
        colorTextDisabled: colors.gray400,
        borderColorDisabled: colors.gray300,
      },
      Tabs: {
        colorBgContainer: colors.surface,
      },
    },
  };
};
